import { render, staticRenderFns } from "./EditSPEmployeeProfileHeader.vue?vue&type=template&id=d41710c8&scoped=true"
import script from "./EditSPEmployeeProfileHeader.vue?vue&type=script&lang=js"
export * from "./EditSPEmployeeProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./EditSPEmployeeProfileHeader.vue?vue&type=style&index=0&id=d41710c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41710c8",
  null
  
)

export default component.exports